/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const mutateSetEdgeEdgeDescriptionMax = 2000;

export const mutateSetEdgeEdgeKeyMax = 200;

export const mutateSetEdgeExpectedOutgoingRevisionMax = 128;

export const mutateSetEdgeFromClientIdMax = 36;

export const mutateSetEdgeFromClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const mutateSetEdgeMaxCountMin = 0;

export const mutateSetEdgeMinCountMin = 0;

export const mutateSetEdgeToClientIdMax = 36;

export const mutateSetEdgeToClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');

export const MutateSetEdge = zod.object({
  carbonCopy: zod.boolean().optional(),
  certainty: zod.enum(['ASSERTED', 'INFERRED', 'SUGGESTED']).optional(),
  edgeDescription: zod
    .string()
    .max(mutateSetEdgeEdgeDescriptionMax)
    .nullish()
    .describe(
      'Authored edge text. An explicit empty string is a value and is stored; descriptions never define edge identity.',
    ),
  edgeKey: zod
    .string()
    .max(mutateSetEdgeEdgeKeyMax)
    .nullish()
    .describe(
      'Schema slot key on a TYPE→TYPE declaration: lower snake_case, unique per source TYPE across CONTAINS and INCLUDES. Preserved across a target rename or reorder — never re-derived from a changed type name. Omission preserves the stored key; null clears it. INSTANCE CONTAINS role keys use lower snake_case. Omission preserves an existing role or creates an unkeyed edge.',
    ),
  edgeType: zod.enum(['CONTAINS', 'RELATES_TO', 'INCLUDES']),
  expectedOutgoingRevision: zod
    .string()
    .min(1)
    .max(mutateSetEdgeExpectedOutgoingRevisionMax)
    .optional()
    .describe(
      'Opaque revision of a source node’s outgoing edges and TYPE policy state, as returned by GET \/content\/{lineageUuid}. Supplied here it is a precondition: the write is refused with 409 if the source has changed since. A node UUID alone is insufficient — an edge-only change does not version its source.',
    ),
  fromClientId: zod
    .string()
    .min(1)
    .max(mutateSetEdgeFromClientIdMax)
    .regex(mutateSetEdgeFromClientIdRegExp)
    .optional()
    .describe(
      'Caller-supplied reference for a node added in THIS request, unique within it. Wires edges to not-yet-persisted nodes and keys the response’s clientIdMap. Lowercase letters, numbers, and ._:- only.',
    ),
  fromContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
  maxCount: zod.int().min(mutateSetEdgeMaxCountMin).nullish(),
  minCount: zod.int().min(mutateSetEdgeMinCountMin).nullish(),
  position: zod.int().nullish(),
  toClientId: zod
    .string()
    .min(1)
    .max(mutateSetEdgeToClientIdMax)
    .regex(mutateSetEdgeToClientIdRegExp)
    .optional()
    .describe(
      'Caller-supplied reference for a node added in THIS request, unique within it. Wires edges to not-yet-persisted nodes and keys the response’s clientIdMap. Lowercase letters, numbers, and ._:- only.',
    ),
  toContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
});

export type MutateSetEdge = zod.input<typeof MutateSetEdge>;
export type MutateSetEdgeOutput = zod.output<typeof MutateSetEdge>;
